export const removeLocaleFromPathname = (url?: string): string => {
    if (!url) {
        return '';
    }

    // Match pattern /xx/xx/
    const regex = /^\/[a-z]{2}\/[a-z]{2}(\/|$)/;
    return url.replace(regex, '/');
};
